import { render, staticRenderFns } from "./BaotongScheme.vue?vue&type=template&id=bc7018bc&scoped=true"
import script from "./BaotongScheme.vue?vue&type=script&lang=js"
export * from "./BaotongScheme.vue?vue&type=script&lang=js"
import style0 from "./BaotongScheme.vue?vue&type=style&index=0&id=bc7018bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7018bc",
  null
  
)

export default component.exports